module.exports = __webpack_public_path__ + "img/Sales.4dffe8eb.svg";